import script from "./messages-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./messages-content.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__